import React, {useState, useEffect, useMemo} from 'react'
import {useSelector} from 'react-redux'
import {useFirebase} from 'react-redux-firebase'
import {fire_storage} from '../../store'

import {PrimaryButton} from '../../components/UI/PrimaryButton'
import {PhotoInput} from '../../components/UI/PhotoInput'
import {Loading} from '../../components/UI/Loading'

import {processNewPhoto} from '../../functions/processNewPhoto'
import {getFormatedData} from '../../functions/getFormatedData'

import {MainContainer as ChangeCategoryContainer} from './styled_components'

export function ChangeCategory({go_back}) {

    const database = useFirebase()
    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const products = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.products_list))

    const [dataAcceptChangeAvailable, setDataAcceptChangeAvailable] = useState(false)
    const [defaultDataHasSet, setDefaultDataHasSet] = useState(false)
    const [loading, setLoading] = useState(false)

    const [categoryForChangeData, setCategoryForChangeData] = useState('')
    const [categoryForChangeName, setCategoryForChangeName] = useState('')

    const [newCategoryName, setNewCategoryName] = useState('')
    const [categoryPicture, setCategoryPicture] = useState('')


    const [areThereSubcategoriesInSelectedCategory, setAreThereSubcategoriesInSelectedCategory] = useState(false)

    const CategoryPictureInput = useMemo(() => <PhotoInput picture={categoryPicture}
                                                           setPicture={setCategoryPicture}/>, [categoryPicture])

    function setDefaultData(data) {
        const defaultCategory = data[0]
        setCategoryForChangeData(defaultCategory)
        setCategoryForChangeName(defaultCategory.category_name)
        setNewCategoryName(defaultCategory.category_name)
        setCategoryPicture(defaultCategory.category_picture)

        setDefaultDataHasSet(true)
    }

    function checkDataAcceptChangeAvailable() {
        const formatted_category_name = newCategoryName.trim().replace(/\s{2,}/g, ' ')
        const name_not_empty_and_doesnt_match_with_other = (formatted_category_name.length !== 0) && (categories.filter(category => (category.category_name.toLowerCase() === formatted_category_name) && (formatted_category_name !== categoryForChangeName)).length === 0)
        // eslint-disable-next-line
        const default_picture = (categoryForChangeData.category_picture === categoryPicture) || (categoryForChangeData.category_picture == false && categoryPicture == false)
        const category_contains_subcategories = categories.filter(category => category.parent_category_name === categoryForChangeName).length !== 0
        const not_the_same_name = formatted_category_name !== categoryForChangeData.category_name

        if (category_contains_subcategories) {
            setAreThereSubcategoriesInSelectedCategory(true)
        } else {
            setAreThereSubcategoriesInSelectedCategory(false)
        }

        if ((name_not_empty_and_doesnt_match_with_other && (default_picture === false))
            || (default_picture && name_not_empty_and_doesnt_match_with_other && not_the_same_name)) {
            setDataAcceptChangeAvailable(true)
        } else {
            setDataAcceptChangeAvailable(false)
        }

    }

    useEffect(() => {
        if (!defaultDataHasSet && (categories.length > 0)) {
            setDefaultData(categories)
        }
        checkDataAcceptChangeAvailable()
    })

    function handleSubmit() {

        const formatted_category_name = newCategoryName.trim().replace(/\s{2,}/g, ' ')
        const products_in_selected_category = products.filter(product => product.category === categoryForChangeName)
        const category_name_the_same = categoryForChangeName === formatted_category_name
        // eslint-disable-next-line
        const default_picture = (categoryForChangeData.category_picture === categoryPicture) || (categoryForChangeData.category_picture == false && categoryPicture === false)

        async function updateDataInDatabase(picture_data) {
            const new_category_data = {
                category_name: formatted_category_name,
                parent_category_name: categoryForChangeData.parent_category_name,
                category_picture: picture_data,
            }
            try {
                await database.ref(`products/categories/${categoryForChangeData.key}`).set(new_category_data)
                alert('Данные успешно обновлены!')
                setLoading(false)
                setDefaultDataHasSet(false)
            } catch (err) {
                alert('Что-то пошло не так при обновлении данных.')
                console.log(err);
            }
        }
        async function updateCategoryNameForProduct (product) {
                try {
                    await database.ref(`products/products_list/${product.key}/category`).set(formatted_category_name)
                } catch (err) {
                    alert('Что-то пошло не так при обновлении названия категории у продуктов')
                }
        }
        async function uploadPictureAndUpdateData() {
            const ref = fire_storage.ref(`img/products/categories/`)
            setLoading(true)

            try {
                const picture_data = await processNewPhoto(ref, categoryPicture)
                updateDataInDatabase(picture_data)
            } catch (err) {
                alert('Что-то пошло не так')
                console.log(err)
            } finally {
                setLoading(false)
            }
        }

        if (default_picture) {
            setLoading(true)

            if (products_in_selected_category.length !== 0) {
                console.log('Меняем имя и категорию у продуктов');

                // Update Category For Product
                products_in_selected_category.forEach( product => updateCategoryNameForProduct(product) )
                updateDataInDatabase(categoryForChangeData.category_picture)

            } else {
                console.log('Меняем только имя')
                updateDataInDatabase(categoryForChangeData.category_picture)
            }
        } else if ((default_picture === false) && category_name_the_same) {
            console.log('Меняем только фото');
            setLoading(true)

            if (categoryPicture === false) {
                console.log('Удаляем фото');
                updateDataInDatabase([''])
            } else {
                console.log('Загружаем новое фото');
                uploadPictureAndUpdateData()
            }
        } else {
            setLoading(true)

            if (products_in_selected_category.length !== 0) {
                console.log('Меняем фото, имя и категории у продуктов в категории');

                products_in_selected_category.forEach( product => updateCategoryNameForProduct(product) )

                if (categoryPicture === false) {
                    console.log('Удаляем фото');
                    updateDataInDatabase([''])
                } else {
                    console.log('Загружаем новое фото');
                    uploadPictureAndUpdateData()
                }

            } else {
                console.log('Меняем только фото и имя')

                if (categoryPicture === false) {
                    console.log('Удаляем фото');

                    updateDataInDatabase([''])
                } else {
                    console.log('Загружаем новое фото');

                    uploadPictureAndUpdateData()
                }
            }
        }

    }

    function handleDelete() {
        const del_confirm = window.confirm('Вы действительно хотите удалить категорию? Все содержащиеся в ней продукты также будут удалены! Если в категории есть подкатегории - удалите сначала их')

        if (del_confirm) {
            const products_in_category = products.filter(product => product.category === categoryForChangeName)
            const is_there_products = products_in_category.length > 0
            const is_there_categories = categories.filter(category => category.parent_category_name === categoryForChangeName).length > 0

            async function deleteCategoryDataFromDatabase(categoryForChangeData) {
                try {
                    await database.ref(`products/categories/${categoryForChangeData.key}`).remove()
                    setDefaultDataHasSet(false)
                    alert('Категория и продукция в ней успешно удалены!')
                } catch (err) {
                    alert('Что-то пошло не так при удалении категории')
                    console.log(err);
                    return
                } finally {
                    setLoading(false)
                }
            }

            async function deleteProductsFromDatabase(product) {
                try {
                    await database.ref(`products/products_list/${product.key}`).remove()
                } catch (err) {
                    alert('Что-то пошло не так при удалении товаров в категории')
                    console.log(err);
                    return
                } finally {
                    setLoading(false)
                }
            }

            if (is_there_categories) {
                alert('В категории есть подкатегории. Пожалуйста, сперва удалите их.')
                return

            } else if (is_there_products) {
                setLoading(true)
                products_in_category.forEach(product => deleteProductsFromDatabase(product))
                deleteCategoryDataFromDatabase(categoryForChangeData)
            } else {
                setLoading(true)
                deleteCategoryDataFromDatabase(categoryForChangeData)
            }
        }
    }

    function handleCategoryForChangeSelect(selected_category_name) {
        const selected_category = categories.filter(category => category.category_name === selected_category_name)[0]
        setCategoryForChangeData(selected_category)
        setCategoryForChangeName(selected_category_name)
        setNewCategoryName(selected_category_name)
        setCategoryPicture(selected_category.category_picture[0] !== '' ? selected_category.category_picture : false)
    }

    return (
        <ChangeCategoryContainer>

            <div className="inputs">

                {CategoryPictureInput}

                {
                    categories && categories.length > 0
                        ? <>
                            <p className='input-description'>Редактируемая категория</p>
                            <select className='select' value={categoryForChangeName}
                                    onChange={(e) => handleCategoryForChangeSelect(e.target.value)}>
                                {categories.map(category => <option value={category.category_name}
                                                                    key={category.key}>{category.category_name}</option>)}
                            </select>
                        </>
                        : null
                }

                <div>
                    {
                        areThereSubcategoriesInSelectedCategory
                            ? <p className='input-description'>Можно изменить только фото, так как категория содержит
                                подкатегории</p>
                            : <p className='input-description'>Название категории (не должно совпадать с уже
                                существующими)</p>
                    }
                </div>
                <input className='input' placeholder='Название категории' type="text"
                       value={newCategoryName}
                       onChange={(e) => setNewCategoryName(e.target.value)}
                       disabled={areThereSubcategoriesInSelectedCategory}/>

            </div>

            {loading
                ? <Loading lighten/>
                : dataAcceptChangeAvailable
                    ? <PrimaryButton onClick={() => handleSubmit()} lighten className='submit-button'>Применить
                        изменения</PrimaryButton>
                    : null
            }

            {
                areThereSubcategoriesInSelectedCategory
                    ? null
                    : <p className='link-button delete-button' onClick={() => handleDelete()}>Удалить категорию</p>
            }

            <p className='link-button' onClick={() => go_back('')}>Назад</p>

        </ChangeCategoryContainer>
    )
}
